import { render, staticRenderFns } from "./defaultSection.vue?vue&type=template&id=13be569a&scoped=true"
import script from "./defaultSection.vue?vue&type=script&lang=js"
export * from "./defaultSection.vue?vue&type=script&lang=js"
import style0 from "./defaultSection.vue?vue&type=style&index=0&id=13be569a&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be569a",
  null
  
)

export default component.exports